import { render, staticRenderFns } from "./Settings_Sites.vue?vue&type=template&id=626088f4&scoped=true"
import script from "./Settings_Sites.vue?vue&type=script&lang=js"
export * from "./Settings_Sites.vue?vue&type=script&lang=js"
import style0 from "./Settings_Sites.vue?vue&type=style&index=0&id=626088f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626088f4",
  null
  
)

export default component.exports